var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#006FE4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.646 2.42v47.16c0 1.574-1.51 2.728-3.07 2.347L1.871 45.88C.771 45.611 0 44.644 0 43.534V8.466c0-1.11.772-2.077 1.871-2.346L26.576.073c1.56-.381 3.07.773 3.07 2.347zm-10.5 19.348c-1.705 0-3.088 1.353-3.088 3.023 0 1.67 1.383 3.023 3.088 3.023 1.706 0 3.088-1.354 3.088-3.023 0-1.67-1.382-3.023-3.088-3.023zM44.16 35.862c1.194 0 2.162.803 2.162 1.793v7.173c0 .99-.968 1.793-2.162 1.793h-8.647c-1.193 0-2.161-.803-2.161-1.793 0-.99.968-1.794 2.161-1.794h6.485v-5.379c0-.99.968-1.793 2.162-1.793zM46.097 31.796c-.724.64-1.897.64-2.62 0-.724-.64-.724-1.678 0-2.319l1.99-1.76H35.205c-1.024 0-1.853-.734-1.853-1.64 0-.905.83-1.639 1.853-1.639h10.437l-2.165-1.915c-.724-.64-.724-1.679 0-2.319.723-.64 1.896-.64 2.62 0l5.24 4.637c.724.64.724 1.678 0 2.318l-5.24 4.637zM44.16 5.38c1.194 0 2.162.802 2.162 1.792v7.173c0 .99-.968 1.793-2.162 1.793s-2.162-.803-2.162-1.793v-5.38h-6.485c-1.193 0-2.161-.802-2.161-1.793 0-.99.968-1.793 2.161-1.793h8.647z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.6401146986a79429cae7ad54129dae21.svg";
export { ForwardRef as ReactComponent };